import React, { memo, useState, useContext, useEffect } from "react";
import { Button, Modal, Form, Card, Col, Row, Spinner } from "react-bootstrap";
import { useSelector, useDispatch } from 'react-redux';
import { closeModal } from "slices/stillageCollections";
import FalconCloseButton from "components/common/FalconCloseButton";
import classNames from "classnames";
import Flex from "components/common/Flex";
import { updateStillageCollection } from "services/stillageCollections";
import { toast } from "react-toastify";
import { StillageCollectionDataContext } from "context/Context";
import { getOptionsByKey } from "services/optionLists";

const MarkAsNotCollected = () => {
    const [selected, setSelected] = useState([]);
    const [loading, setLoading] = useState(false);
    const [reasons, setReasons] = useState([]);
    const [reason, setReason] = useState('');
    const { markNotCollected: { show, data: { collectionNote, stillagesNotCollected } } } = useSelector(state => state.stillageCollections);
    const { data } = useContext(StillageCollectionDataContext);
    const dispatch = useDispatch();

    useEffect(() => getOptionsByKey('stillage.not.collected').then(res => setReasons(res)), []);

    const collectionDate = data?.tableData?.find(x => x.collectionNote === collectionNote)?.collectionDate;

    const removeStillage = (state, no) => {
        let stills = [...state];
        stills.splice(state.indexOf(no), 1);
        return stills;
    }

    const handleClick = async () => {
        setLoading(true);
        try {
            const res = await updateStillageCollection(collectionNote, collectionDate, selected, "notCollected", reason);

            if (res?.success) {
                toast.success(`Stillage(s) successfully updated to not collected! `, res?.message || '');
                setTimeout(() => dispatch(closeModal()), 1000)
            }
            else
                toast.error('There was a problem updating the stillages! Please try again. ', res?.message || '');
        } catch (err) {
            toast.error('Something went wrong! ', err.message);
            console.error(err);
        } finally {
            setLoading(false);
            setSelected([]);
        }
    }

    return (
        <Modal show={show}>
            <Modal.Header>
                <Modal.Title>Mark A Stillage As Not Collected - <span className="d-block">{collectionNote}</span></Modal.Title>
                <FalconCloseButton onClick={() => dispatch(closeModal())} /></Modal.Header>
            <Modal.Body>
                <p className="mb-3 p-2">Select stillage(s) from the list, along with a reason, below and press confirm to mark them as not collected.</p>
                <Row>
                    {stillagesNotCollected ?
                        stillagesNotCollected?.map(x => (
                            <Col key={x} xs={3}>
                                <Card
                                    className={classNames('mb-3 p-2 cursor-pointer user-select-none', {
                                        'bg-danger': selected.includes(x), 'text-light': selected.includes(x)
                                    })}
                                    onClick={() =>
                                        !loading ?
                                            (selected.includes(x)) ?
                                                setSelected(prev => removeStillage(prev, x)) :
                                                setSelected(prev => [...prev, x]) :
                                            null
                                    }>
                                    <Flex justifyContent='between'>
                                        <Form.Check
                                            checked={selected.includes(x)}
                                            isInvalid
                                            type='checkbox'
                                            id={`chbx_${x}`}
                                            onChange={e =>
                                                !loading ?
                                                    (e.target.checked ?
                                                        setSelected(prev => [...prev, x]) :
                                                        setSelected(prev => removeStillage(prev, x))) :
                                                    null
                                            }
                                        />
                                        <div>{x}</div>
                                    </Flex>
                                </Card>
                            </Col>
                        )) :
                        <Col xs={12} className="text-center">No Stillages left update</Col>
                    }
                    <Col xs={12}>
                        <Form.Label>Reason Not Collected</Form.Label>
                        <Form.Select
                            onChange={(e) => setReason(e.target.value != 0 ? e.target.value : '')}>
                            <option value={0}>--Select Item--</option>
                            {reasons.map(x => <option key={x.id} value={x.name}>{x.name}</option>)}
                        </Form.Select>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    disabled={loading}
                    onClick={handleClick}>
                    Confirm {loading && <span><Spinner size="sm" variant="light" /></span>}</Button>
                <Button
                    variant="secondary"
                    onClick={() => dispatch(closeModal())}
                    disabled={loading}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default memo(MarkAsNotCollected);